/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {Data3} from './Data3';
import {Data3FromJSON, Data3FromJSONTyped, Data3ToJSON} from './Data3';
import type {Position} from './Position';
import {PositionFromJSON, PositionFromJSONTyped, PositionToJSON} from './Position';
import type {ERFElement} from './ERFElement';
import {ERFElementFromJSON, ERFElementFromJSONTyped, ERFElementToJSON} from './ERFElement';
import type {Id} from './Id';
import {IdFromJSON, IdFromJSONTyped, IdToJSON} from './Id';

/**
 *
 * @export
 * @interface WorkZoneElement
 */
export interface WorkZoneElement {
  /**
   *
   * @type {Id}
   * @memberof WorkZoneElement
   */
  id: Id;
  /**
   *
   * @type {ERFElement}
   * @memberof WorkZoneElement
   */
  type: ERFElement;
  /**
   *
   * @type {Position}
   * @memberof WorkZoneElement
   */
  position: Position;
  /**
   *
   * @type {string}
   * @memberof WorkZoneElement
   */
  parentId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof WorkZoneElement
   */
  deletable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkZoneElement
   */
  connectable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkZoneElement
   */
  draggable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkZoneElement
   */
  selectable?: boolean;
  /**
   *
   * @type {Data3}
   * @memberof WorkZoneElement
   */
  data: Data3;
}

/**
 * Check if a given object implements the WorkZoneElement interface.
 */
export function instanceOfWorkZoneElement(value: object): value is WorkZoneElement {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('position' in value) || value['position'] === undefined) return false;
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function WorkZoneElementFromJSON(json: any): WorkZoneElement {
  return WorkZoneElementFromJSONTyped(json, false);
}

export function WorkZoneElementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WorkZoneElement {
  if (json == null) {
    return json;
  }
  return {
    id: IdFromJSON(json['id']),
    type: ERFElementFromJSON(json['type']),
    position: PositionFromJSON(json['position']),
    parentId: json['parentId'] == null ? undefined : json['parentId'],
    deletable: json['deletable'] == null ? undefined : json['deletable'],
    connectable: json['connectable'] == null ? undefined : json['connectable'],
    draggable: json['draggable'] == null ? undefined : json['draggable'],
    selectable: json['selectable'] == null ? undefined : json['selectable'],
    data: Data3FromJSON(json['data'])
  };
}

export function WorkZoneElementToJSON(value?: WorkZoneElement | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: IdToJSON(value['id']),
    type: ERFElementToJSON(value['type']),
    position: PositionToJSON(value['position']),
    parentId: value['parentId'],
    deletable: value['deletable'],
    connectable: value['connectable'],
    draggable: value['draggable'],
    selectable: value['selectable'],
    data: Data3ToJSON(value['data'])
  };
}
